import React from 'react'
import { Product } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'
import { formatDateTimeStampWithlocale } from '@/lib/formatDate'
import UpdateIcon from '@mui/icons-material/Update'
import InventoryIcon from '@mui/icons-material/Inventory'
import EventIcon from '@mui/icons-material/Event'
import Tooltip from '@mui/material/Tooltip'
import { getDateAvailableProduct } from '@/components/Basket/BasketProductPlanningButton'
import { useStyleProductResume } from '@/components/Product/ProductResume'

type Props = {
  product: Product | ProductsBasket
  displayDateAvailable: boolean
  list?: boolean
  className?: string
}

/**
 * Date de livraison du planning de la marque, et stock disponible tout de suite.
 *
 * Avec du stock, la quantite disponible devient l'information principale et la date se reduit a
 * une icone calendrier + JJ/MM, la date complete en infobulle (retour LAP du 04/11/2026). La date
 * n'est pas supprimee : la commande part au planning de la marque, sauf degroupement au panier.
 * Sans stock, « Livré à partir du » reste en clair.
 */
const ProductAvaibleAfter: React.FC<Props> = ({
  product,
  displayDateAvailable,
  list,
  className,
}) => {
  const classesResume = useStyleProductResume()

  const dateAvailable = getDateAvailableProduct(product)
  if (!dateAvailable || !displayDateAvailable) return <></>

  const timestamp = Number(dateAvailable)
  const amount = Number(product.amount)
  const rootClassName = `${classesResume.rootInfoProduct} ${className || ''}`
  const rootStyle = list ? { paddingLeft: 0 } : {}

  if (amount > Number(product.coeffQuantity)) {
    return (
      <div className={rootClassName} style={rootStyle}>
        <div className={classesResume.svgInfoProduct}>
          <InventoryIcon style={{ color: '#E34F00' }} width={8} height={8} />
        </div>
        <span className={`text-[#E34F00] ${classesResume.infoProduct}`}>
          {amount}{' '}
          {t({ id: amount > 1 ? 'web_disponibles_immediatement' : 'web_disponible_immediatement' })}
        </span>
        <Tooltip
          title={`${t({ id: 'web_livrable_a_partir_du' })} ${formatDateTimeStampWithlocale(timestamp, 'fr')}`}
          enterTouchDelay={0}
          arrow
        >
          <span className="ml-2 inline-flex items-center gap-0.5 text-xs text-gray-500">
            <EventIcon sx={{ fontSize: 14 }} aria-hidden="true" />
            {formatDateTimeStampWithlocale(timestamp, 'fr', 'dd/MM')}
          </span>
        </Tooltip>
      </div>
    )
  }

  return (
    <div className={rootClassName} style={rootStyle}>
      <div className={classesResume.svgInfoProduct}>
        <UpdateIcon style={{ color: '#E34F00' }} width={8} height={8} />
      </div>
      <span className={`text-[#E34F00] ${classesResume.infoProduct}`}>
        {t({ id: 'web_planning_shipping_current_start_light' })}{' '}
        {formatDateTimeStampWithlocale(timestamp, 'fr')}
      </span>
    </div>
  )
}

export default ProductAvaibleAfter
